// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"120":"0b0f2fba","156":"6262407e","679":"1f63dac8","856":"95ba30fa"}[chunkId] + ".js";
};